const mockData = [
  {
    title: 'In The Night - VINYL',
    description: 'Hamme',
    link: '../../landing_pages/hamme/in-the-night/',
    image:
      '../../landing_pages/hamme/in-the-night/assets/img/artwork-vinyl.png',
    prices: {
      USD: 30.0,
      AUD: 40.0,
      CAD: 35.0,
    },
    sku: 'HAMME-VN-001',
    category: 'Vinyl',
    availability: 'In Stock',
    weight: '500g',
    dimensions: '31.5cm x 31.5cm x 0.5cm',
    format: '12-inch Vinyl',
  },
  {
    title: 'In The Night - CD',
    description: 'Hamme',
    link: '../../landing_pages/hamme/in-the-night/',
    image: '../../landing_pages/hamme/in-the-night/assets/img/artwork-cd.png',
    prices: {
      USD: 15.0,
      AUD: 20.0,
      CAD: 18.0,
    },
    sku: 'HAMME-CD-001',
    category: 'CD',
    availability: 'In Stock',
    weight: '100g',
    dimensions: '14.2cm x 12.5cm x 1cm',
    format: 'Compact Disc',
  },
  {
    title: 'In The Night - DIGITAL',
    description: 'Hamme',
    link: '../../landing_pages/hamme/in-the-night/',
    image: '../../landing_pages/hamme/in-the-night/assets/img/artwork.jpg',
    prices: {
      USD: 10.0,
      AUD: 13.0,
      CAD: 12.0,
    },
    sku: 'HAMME-DG-001',
    category: 'Digital',
    availability: 'Available for Download',
    fileSize: '320MB',
    format: 'MP3/FLAC',
  },
  {
    title: 'Classic Tee',
    description: 'Comfortable and stylish tee for everyday wear.',
    link: '../../landing_pages/clothing/classic-tee/',
    image:
      '../../landing_pages/clothing/classic-tee/assets/img/classic-tee.png',
    prices: {
      USD: 25.0,
      AUD: 33.0,
      CAD: 30.0,
    },
    sku: 'TEE-CLASSIC-001',
    category: 'Tees',
    availability: 'In Stock',
    sizeOptions: ['S', 'M', 'L', 'XL', 'XXL'],
    colorOptions: ['Black', 'White', 'Navy', 'Gray'],
    material: '100% Cotton',
  },
  {
    title: 'Cozy Hoodie',
    description: 'Stay warm with this soft and durable hoodie.',
    link: '../../landing_pages/clothing/cozy-hoodie/',
    image:
      '../../landing_pages/clothing/cozy-hoodie/assets/img/cozy-hoodie.png',
    prices: {
      USD: 50.0,
      AUD: 65.0,
      CAD: 60.0,
    },
    sku: 'HOODIE-COZY-002',
    category: 'Hoodies',
    availability: 'In Stock',
    sizeOptions: ['S', 'M', 'L', 'XL', 'XXL'],
    colorOptions: ['Black', 'Maroon', 'Olive Green', 'Gray'],
    material: '80% Cotton, 20% Polyester',
    features: ['Kangaroo Pocket', 'Drawstring Hood'],
  },
  {
    title: 'Puffer Jacket',
    description: 'Lightweight yet warm puffer jacket for all seasons.',
    link: '../../landing_pages/clothing/puffer-jacket/',
    image:
      '../../landing_pages/clothing/puffer-jacket/assets/img/puffer-jacket.png',
    prices: {
      USD: 90.0,
      AUD: 120.0,
      CAD: 110.0,
    },
    sku: 'PUFFER-JACKET-003',
    category: 'Outerwear',
    availability: 'Limited Stock',
    sizeOptions: ['S', 'M', 'L', 'XL', 'XXL'],
    colorOptions: ['Black', 'Navy', 'Beige'],
    material: 'Polyester with Insulated Fill',
    features: ['Water-Resistant', 'Zippered Pockets'],
  },
  {
    title: 'Classic Polo',
    description: 'Elegant and versatile polo shirt.',
    link: '../../landing_pages/clothing/classic-polo/',
    image:
      '../../landing_pages/clothing/classic-polo/assets/img/classic-polo.png',
    prices: {
      USD: 35.0,
      AUD: 45.0,
      CAD: 40.0,
    },
    sku: 'POLO-CLASSIC-004',
    category: 'Polos',
    availability: 'In Stock',
    sizeOptions: ['S', 'M', 'L', 'XL', 'XXL'],
    colorOptions: ['White', 'Black', 'Navy', 'Burgundy'],
    material: 'Cotton-Polyester Blend',
    features: ['Button Placket', 'Breathable Fabric'],
  },
  {
    title: 'Logo Snapback',
    description: 'Stylish snapback hat with embroidered logo.',
    link: '../../landing_pages/accessories/logo-snapback/',
    image:
      '../../landing_pages/accessories/logo-snapback/assets/img/logo-snapback.png',
    prices: {
      USD: 20.0,
      AUD: 25.0,
      CAD: 23.0,
    },
    sku: 'HEADWEAR-SNAPBACK-005',
    category: 'Headwear',
    availability: 'In Stock',
    colorOptions: ['Black', 'Gray', 'Navy'],
    material: '100% Cotton',
    features: ['Adjustable Strap', 'Flat Brim'],
  },
  {
    title: 'Athletic Shorts',
    description: 'Lightweight and breathable shorts for workouts.',
    link: '../../landing_pages/clothing/athletic-shorts/',
    image:
      '../../landing_pages/clothing/athletic-shorts/assets/img/athletic-shorts.png',
    prices: {
      USD: 30.0,
      AUD: 40.0,
      CAD: 35.0,
    },
    sku: 'SHORTS-ATHLETIC-006',
    category: 'Shorts',
    availability: 'In Stock',
    sizeOptions: ['S', 'M', 'L', 'XL'],
    colorOptions: ['Black', 'Gray', 'Navy'],
    material: 'Moisture-Wicking Polyester',
    features: ['Elastic Waistband', 'Side Pockets'],
  },
  {
    title: 'Comfy Sweatpants',
    description: 'Soft and cozy sweatpants for lounging or working out.',
    link: '../../landing_pages/clothing/comfy-sweatpants/',
    image:
      '../../landing_pages/clothing/comfy-sweatpants/assets/img/comfy-sweatpants.png',
    prices: {
      USD: 40.0,
      AUD: 50.0,
      CAD: 45.0,
    },
    sku: 'SWEATPANTS-COMFY-007',
    category: 'Sweatpants',
    availability: 'In Stock',
    sizeOptions: ['S', 'M', 'L', 'XL'],
    colorOptions: ['Black', 'Gray', 'Navy'],
    material: 'Fleece-Lined Cotton Blend',
  },
  {
    title: 'Logo Socks (3-Pack)',
    description: 'High-quality socks with a subtle logo design.',
    link: '../../landing_pages/accessories/logo-socks/',
    image:
      '../../landing_pages/accessories/logo-socks/assets/img/logo-socks.png',
    prices: {
      USD: 15.0,
      AUD: 20.0,
      CAD: 18.0,
    },
    sku: 'SOCKS-LOGO-008',
    category: 'Socks',
    availability: 'In Stock',
    sizeOptions: ['One Size'],
    colorOptions: ['White', 'Black', 'Gray'],
    material: 'Cotton-Spandex Blend',
  },
  {
    title: 'Leather Belt',
    description: 'Durable leather belt with a sleek buckle.',
    link: '../../landing_pages/accessories/leather-belt/',
    image:
      '../../landing_pages/accessories/leather-belt/assets/img/leather-belt.png',
    prices: {
      USD: 30.0,
      AUD: 40.0,
      CAD: 35.0,
    },
    sku: 'BELT-LEATHER-009',
    category: 'Accessories',
    availability: 'In Stock',
    sizeOptions: ['S', 'M', 'L', 'XL'],
    colorOptions: ['Black', 'Brown'],
    material: 'Genuine Leather',
  },
]

const search = document.getElementById('search-button')
const spotlightOverlay = document.querySelector('.spotlight-overlay')
const searchInput = document.querySelector('.spotlight-input')
const resultsContainer = document.querySelector('.spotlight-results')

// Function to toggle Spotlight visibility
const toggleSpotlight = (show) => {
  spotlightOverlay.style.display = show ? 'flex' : 'none'
  if (show) {
    searchInput.focus() // Focus the input field when Spotlight is shown
    searchInput.value = '' // Clear the input field when opening Spotlight
  } else {
    searchInput.value = '' // Clear search input
    resultsContainer.innerHTML = '' // Clear search results
  }
}

if (search) {
  search.addEventListener('click', () => {
    const isSpotlightVisible = spotlightOverlay.style.display === 'flex'
    toggleSpotlight(!isSpotlightVisible) // Toggle Spotlight visibility
  })
}

// Function to render search results
const renderResults = (query) => {
  const filteredData = mockData.filter((item) =>
    item.title.toLowerCase().includes(query.toLowerCase())
  )
  resultsContainer.innerHTML = filteredData
    .map(
      (item) => `
            <div class="result-item" data-link="${item.link}" data-image="${item.image || ''}">
                <img src="${item.image || 'https://via.placeholder.com/32'}" alt="${item.title}"> <!-- Use the item.image or a default placeholder -->
                <div>
                    <h3>${item.title}</h3>
                    <p>${item.description}</p>
                </div>
            </div>
        `
    )
    .join('')
}

// Function to open the first result and reset the search results
const openFirstResult = () => {
  const firstResult = resultsContainer.querySelector('.result-item')
  if (firstResult) {
    const link = firstResult.dataset.link
    const image = firstResult.dataset.image

    // Reset search results after opening a result
    resultsContainer.innerHTML = ''

    if (link) {
      toggleSpotlight(false) // Hide the overlay
      window.open(link, '_blank') // Open the link in a new tab
    }
    if (image) {
      toggleSpotlight(false) // Hide the overlay
    }
  }
}

// Event Listener for result item clicks
resultsContainer.addEventListener('click', (e) => {
  const resultItem = e.target.closest('.result-item')
  if (resultItem) {
    const link = resultItem.dataset.link
    const image = resultItem.dataset.image

    // Reset the search results
    resultsContainer.innerHTML = ''

    if (link) {
      toggleSpotlight(false) // Hide the overlay
      window.open(link, '_blank') // Open the link in a new tab
    }
    if (image) {
      toggleSpotlight(false) // Hide the overlay
    }
  }
})

// Event Listeners
searchInput.addEventListener('input', (e) => {
  const query = e.target.value
  if (query.trim() !== '') {
    renderResults(query)
  } else {
    resultsContainer.innerHTML = '' // Clear results if input is empty
  }
})

searchInput.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
    e.preventDefault() // Prevent default form submission
    openFirstResult() // Open the first result
  }
})

// Show/Hide Spotlight with specific keys
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') toggleSpotlight(false) // Close Spotlight on Escape
})

// Initialize Spotlight
toggleSpotlight(false) // Initially hidden
